import clsx from "clsx";
import React from "react";
import { Button, ButtonAsButtonProps } from "../Button/Button";
import styles from "./SuiteCardChooseButton.module.scss";

type Props = Omit<ButtonAsButtonProps, "renderAs"> & {
  selected: boolean;
};
export const SuiteCardChooseButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ selected, children, className, ...buttonProps }) => {
  const mainButtonProps: Partial<ButtonAsButtonProps> = selected
    ? {
        variant: "secondary",
        className: clsx(className, styles.selected),
        disabled: true,
        iconName: "check"
      }
    : { variant: "accent", className };

  return (
    <Button
      renderAs="button"
      data-content-piece="suite-select"
      {...mainButtonProps}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};
